// config/authTokens.js
// keys for storing tokens and user
export const AUTH_TOKENS = {
  JWT_TOKEN: process.env.REACT_APP_JWT_TOKEN || "jwtToken",
  USER: process.env.REACT_APP_USER || "user",
  REFRESH_TOKEN: process.env.REACT_APP_REFRESH_TOKEN || "refresh",
  EXPIRES: Number(process.env.REACT_APP_EXPIRES) || 30,
  CLIENTID: process.env.REACT_APP_GOOGLE_CLIENT_ID,
  IS_TENANT_DOMAIN_ACTIVE: process.env.REACT_APP_IS_TENANT_DOMAIN_ACTIVE || 'isTenantDomainActive',
  IS_TENANT_REDIRECTION: process.env.REACT_APP_IS_TENANT_REDIRECTION || 'isTenantRedirection',
  TENANT_DOMAIN: process.env.REACT_APP_TENANT_DOMAIN || "tenantDomain",
};
